<p-dialog
  modal
  [styleClass]="dialogStyleClass"
  [header]="header"
  [(visible)]="visible"
  [focusOnShow]="false"
  (onHide)="onCancelClick()"
>
  <ng-content select="[bodyTop]" />

  @if(formConfig){
  <eo-form
    #eoForm
    [config]="formConfig"
    [autofocus]="false"
    [submitButtonVisible]="false"
    (formChange)="onFormChangeHandler($event)"
  />
  }

  <ng-content select="[bodyBottom]" />

  <ng-template pTemplate="footer">
    <div [class]="footerStyleClass">
      <ng-content select="[footer]" />
      @if(cancelVisible){
      <p-button
        outlined
        [icon]="cancelIcon"
        [label]="cancelLabel"
        [disabled]="cancelDisabled"
        [loading]="cancelLoading"
        (onClick)="onCancelClick()"
      />
      }
      <!--  -->
      @if(submitVisible){
      <p-button
        [icon]="submitIcon"
        [label]="submitLabel"
        [disabled]="submitDisabled"
        [loading]="submitLoading"
        (onClick)="onSubmitClick(eoForm?.getFormData())"
      />
      }
    </div>
  </ng-template>
</p-dialog>
